// extracted by mini-css-extract-plugin
export default {"btn":"PrimaryButton_btn__SshKw"};